import { RadioGroup } from "@headlessui/react";
import { useTranslation } from "react-i18next";

import { stepHeadingClassName } from "@/components/Welcome/AuthenticatorSetup/authenticator.utils";
import {
  TwoFactorSmsOption,
  TwoFactorStandardOption,
} from "@/components/Welcome/AuthenticatorSetup/AuthenticatorSetupForm";
import { ChangeTwoFactorAuthenticationMethod } from "@/services/model";

type Props = {
  value: ChangeTwoFactorAuthenticationMethod | null;
  onChange: (method: ChangeTwoFactorAuthenticationMethod) => void;
};

/** "Change 2FA log in method" section of the app user's 2FA settings card. */
export const TwoFactorAppAlternatives = ({ value, onChange }: Props) => {
  const { t } = useTranslation();
  const title = t("portal:user-account.security.2fa.changeOption");

  return (
    <div className="flex flex-col gap-4">
      <h2 className={stepHeadingClassName}>{title}</h2>
      <RadioGroup
        className="flex flex-col gap-4"
        value={value}
        onChange={onChange}
        aria-label={title}
      >
        <TwoFactorSmsOption />
        <TwoFactorStandardOption />
      </RadioGroup>
    </div>
  );
};
